import {
  IInsuranceCoverageFieldCheckResult,
  validateInsuranceCoverageImportData
} from "@wingspanhq/benefits/dist/src/lib/helpers/policyValidation";
import { InsuranceCoverage } from "@wingspanhq/wingspan-api-sdk";

/**
 * The field-level problems that make a coverage unimportable — a missing policy
 * number, a placeholder date, an expiration before the effective date, an
 * already-expired policy, …
 *
 * The rules live in `@wingspanhq/benefits` and are shared with the backend, so
 * they are read rather than restated here. Its input type predates v3 but
 * describes the same wire values — `PolicyType`, `CoverageForm` and the limit
 * types are member-for-member identical to the SDK's enums — and every rule
 * treats a missing field as falsy, so the coverage is handed over structurally.
 * `insurerName` is the one field v3 renamed (`carrier`). The cast targets the
 * validator's own parameter type so no v1 entity interface is named here.
 */
export const selectorInsuranceCoverageIssues = (
  coverage: InsuranceCoverage
): IInsuranceCoverageFieldCheckResult[] =>
  validateInsuranceCoverageImportData({
    ...coverage,
    insurerName: coverage.carrier
  } as unknown as Parameters<typeof validateInsuranceCoverageImportData>[0]);
